import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ dark = false, idPrefix = "newsletter" }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) {
      toast.error("Please add your name and email address.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/newsletter`, { name: name.trim(), email: email.trim() });
      toast.success("Welcome to the movement — you're on the list.");
      setName("");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Please try again in a moment.");
    } finally {
      setSending(false);
    }
  };

  const inputCls = dark
    ? "w-full rounded-full border border-ivory/30 bg-ivory/10 px-5 py-3.5 text-sm text-ivory placeholder:text-ivory/50 focus:border-gold focus:outline-none"
    : "w-full rounded-full border border-forest/25 bg-white px-5 py-3.5 text-sm text-ink placeholder:text-mutedink/60 focus:border-gold focus:outline-none";

  return (
    <form onSubmit={submit} className="w-full space-y-3" data-testid={`${idPrefix}-form`}>
      <div className="grid gap-3 sm:grid-cols-2">
        <input
          type="text"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name"
          aria-label="Your name"
          data-testid={`${idPrefix}-name-input`}
          className={inputCls}
        />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          aria-label="Your email address"
          data-testid={`${idPrefix}-email-input`}
          className={inputCls}
        />
      </div>
      <button
        type="submit"
        disabled={sending}
        data-testid={`${idPrefix}-submit-button`}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-gold px-8 py-3.5 text-sm font-semibold uppercase tracking-[0.2em] text-forest transition-all duration-300 hover:bg-golddark hover:shadow-lg disabled:opacity-60 sm:w-auto"
      >
        {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        Join Us
      </button>
    </form>
  );
}
